import { render, staticRenderFns } from "./ProductAlternativeImage.vue?vue&type=template&id=24d33786&scoped=true"
import script from "./ProductAlternativeImage.vue?vue&type=script&lang=js"
export * from "./ProductAlternativeImage.vue?vue&type=script&lang=js"
import style0 from "./ProductAlternativeImage.vue?vue&type=style&index=0&id=24d33786&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d33786",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/rakarapu/compiere-all/pharmanord2011/template/webapps/buybuttoncompact/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d33786')) {
      api.createRecord('24d33786', component.options)
    } else {
      api.reload('24d33786', component.options)
    }
    module.hot.accept("./ProductAlternativeImage.vue?vue&type=template&id=24d33786&scoped=true", function () {
      api.rerender('24d33786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductAlternativeImage.vue"
export default component.exports